import Hover from "../utils/_hover";

export default class HoverEffect {

	ready() {

        const TEXT_SECTION_BOXES = document.querySelectorAll('.mtt-text-sections-boxes__box-wrap');
        if (TEXT_SECTION_BOXES.length) {
            for (let i = 0; i < TEXT_SECTION_BOXES.length; i++) {
                new Hover(TEXT_SECTION_BOXES[i], '.text-section-box', true);
            }
        }
    }
}